export default "__VITE_PUBLIC_ASSET__a068d4b0__"